import { MessageCircle } from "lucide-react";
import { useWhatsAppNumber, buildWaLink } from "@/lib/whatsapp";

export default function WhatsAppFloat() {
  const number = useWhatsAppNumber();
  if (!number) return null;
  const href = buildWaLink(number, "Hello Oshveda Naturals, I would like to know more about your products.");
  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      data-testid="floating-whatsapp"
      className="fixed bottom-6 right-6 z-50 bg-whatsapp hover:bg-whatsapp-hover text-white rounded-full shadow-lg hover:shadow-xl hover:-translate-y-1 transition-all duration-300 flex items-center gap-2 pl-4 pr-5 py-3"
    >
      <MessageCircle size={20} />
      <span className="text-sm font-semibold">Order on WhatsApp</span>
    </a>
  );
}
